var map = {
	"./": [
		96
	],
	"./CookiesRegulationPage": [
		474,
		1
	],
	"./CookiesRegulationPage.js": [
		474,
		1
	],
	"./Regulation": [
		399
	],
	"./Regulation.js": [
		399
	],
	"./RegulationAvonComponent": [
		909,
		10
	],
	"./RegulationAvonComponent.js": [
		909,
		10
	],
	"./RegulationContainer": [
		398
	],
	"./RegulationContainer.js": [
		398
	],
	"./RegulationDefault": [
		475,
		1
	],
	"./RegulationDefault.js": [
		475,
		1
	],
	"./RegulationIupp": [
		910,
		1
	],
	"./RegulationIupp.js": [
		910,
		1
	],
	"./RegulationPage": [
		260
	],
	"./RegulationPage.js": [
		260
	],
	"./actions": [
		397
	],
	"./actions.js": [
		397
	],
	"./index": [
		96
	],
	"./index.js": [
		96
	],
	"./print.css": [
		727
	],
	"./reducer": [
		396
	],
	"./reducer.js": [
		396
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1928;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/features/Regulation lazy ^\.\/.*$
// module id = 1928
// module chunks = 14